/**
 * 视频通话拒绝消息处理
 */

import { useVideoCallStore } from '@/stores/videoCall'
import { closeVideoCall } from '@/components/VideoCallModal'
import { showToast } from 'vant'
import { closeVideoInvite } from '@/components/VideoInviteModal'
import { t } from '@/locales'
import { track } from '@/utils/tracker'

/**
 * 处理视频通话拒绝
 * 场景：
 * 1. 自己拨打被对方拒绝时会下发
 * 2. 被邀请->还未接通->对方挂断的时候会触发
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export async function handleVideoCallRefuse(event) {
  console.log('[handleVideoCallRefuse] event:', event)
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  const message = messages[0]
  const videoCallStore = useVideoCallStore()

  // 验证是否是当前通话（使用 live_id 判断）
  const { msg_content } = message || {}
  const refuseMessage = message?.content_tips || msg_content?.message
  const currentRoomInfo = videoCallStore.currentRoomInfo // 有 currentRoomInfo 说明是自己拨打的视频电话

  // 如果 live_id 不匹配，说明不是当前通话
  if (String(msg_content.live_id) !== String(currentRoomInfo?.live_id)) {
    return
  }

  // 上报通话结束埋点（被拒绝）
  const { live_id } = msg_content
  track('call_1v1_status_change_video_room', {
    live_id,
    status: 'ended',
    duration: 0, // 被拒绝时通话时长为0
    end_reason: 'anchor_refused',
  })

  showToast(t('videoCall.refused'))

  if (videoCallStore.isCaller) {
    // 关闭等待弹窗
    closeVideoCall()
  }

  if (videoCallStore.isReceiver) {
    closeVideoInvite()
  }
  // 重置通话状态
  videoCallStore.resetCall()

  // 显示拒绝提示
  refuseMessage && showToast(refuseMessage)
}
